import React, { useEffect, useState } from 'react';
import Navbar from '../components/sidebar/Sidebar';
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const [initialLoad, setInitialLoad] = useState(true);
  const { refNumber } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Check if the token is present in sessionStorage
    const token = sessionStorage.getItem('authToken');
    const storedCode = sessionStorage.getItem('responseCode');
    console.log('Stored Code:', storedCode);
    console.log('Before Clearing Session Storage:', sessionStorage);
    console.log('token home', token);
    if (!token || storedCode !== '200') {
      sessionStorage.clear(); // Clear session storage
      console.log('After Clearing Session Storage:', sessionStorage);
      navigate('/'); // Redirect to login or desired route
      return;
    }

    // Navigate to the first tab (Teleconsult) only on initial load
    if (initialLoad) {
      navigate('/home/teleconsult'); // Navigate to the first tab's route
      setInitialLoad(false);
    }
  }, [navigate, initialLoad]);
  return (
    <div className="flex flex-col mb-2">
      {location.pathname !== `/home/HealthVitals/${refNumber}` && (
        <Navbar />
      )}
      {/* Move Outlet below the Navbar */}
      <div className={`flex-grow p-8 mt-6 bg-white h-screen mt-${location.pathname !== `/home/HealthVitals/${refNumber}` ? '14' : '0'} scrollbar-hidden`}>
        <Outlet />
        
      </div>
    </div>
  );
};

export default Home;
